export const SERVER_CONFIG = {
  IP: 'localhost',
  PORT: '5173',
  get BASE_URL() {
    return `http://${this.IP}:${this.PORT}`;
  }
};

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const GENERATE_AD_URL = import.meta.env.VITE_GENERAR_ANUNCIO_URL;
// V3 — usado solo por la generación de la Interfaz V2 (modo Imagen con
// modelo + plantillas). El resto de la app sigue con V2.
export const GENERATE_AD_V3_URL =
  import.meta.env.VITE_GENERAR_ANUNCIO_V3_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_anuncio_v3';
export const GENERATE_VIDEO_CREATOR_URL =
  import.meta.env.VITE_GENERATE_VIDEO_CREATOR_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_video_creator';
// Webhook del modo "Video con influencer" (UGC) de la Interfaz V2. Mismo
// payload/flujo que el Director de Estudio pero con su propio workflow en n8n.
export const GENERATE_VIDEO_INFLUENCER_URL =
  import.meta.env.VITE_GENERATE_VIDEO_INFLUENCER_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/video_influencer';
export const GENERATE_AUDIO_CREATOR_URL =
  import.meta.env.VITE_GENERATE_AUDIO_CREATOR_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_audio_creator';
// Endpoints para traducción de video con lip-sync (HeyGen Video Translate v3).
// Async: START dispara el job y devuelve un jobId; STATUS se polea cada N
// segundos hasta que el video traducido esté listo.
export const TRANSLATE_VIDEO_START_URL =
  import.meta.env.VITE_TRANSLATE_VIDEO_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/traducir_video_creator_start';
export const TRANSLATE_VIDEO_STATUS_URL =
  import.meta.env.VITE_TRANSLATE_VIDEO_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/traducir_video_creator_status';
// Endpoints para borrado de objetos en video (Bria video-erase-object via
// Replicate). Async: START dispara el job (n8n corta el clip, llama a Bria por
// chunk, recose y sube el resultado) y devuelve un jobId; STATUS se polea hasta
// que el video borrado esté listo.
export const BRIA_ERASE_START_URL =
  import.meta.env.VITE_BRIA_ERASE_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/bria_erase_start';
export const BRIA_ERASE_STATUS_URL =
  import.meta.env.VITE_BRIA_ERASE_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/bria_erase_status';
// SAM2 para el pincel inteligente. `sam2_mask`: frame + marcas → máscara del
// frame (preview, ~síncrono/poll corto). `sam2_propagate`: clip + marcas →
// mask-video propagado a todos los frames (async, encadena con bria_erase).
export const SAM2_MASK_URL =
  import.meta.env.VITE_SAM2_MASK_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_mask';
export const SAM2_ERASE_START_URL =
  import.meta.env.VITE_SAM2_ERASE_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_erase_start';
export const SAM2_ERASE_STATUS_URL =
  import.meta.env.VITE_SAM2_ERASE_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_erase_status';
// Poses personalizadas (Interfaz V2): el cliente sube una pose → este webhook
// la copia sobre el muñeco default, guarda en `poses_personalizadas` y devuelve
// la pose. Patrón clonado de `procesar_modelo_propio`.
export const PROCESAR_POSE_URL =
  import.meta.env.VITE_PROCESAR_POSE_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/procesar_pose_subida';

export const GENERATE_AUTH_TOKEN = import.meta.env.VITE_GENERATE_AUTH_TOKEN;

// ─── MercadoPago (captura de tarjeta in-app, Argentina) ────────────────────
// Public key del SDK web de MP. Es pública (segura para el front). En test
// arranca con `TEST-` o `APP_USR-` según la cuenta; en prod, la de producción.
export const MP_PUBLIC_KEY = import.meta.env.VITE_MP_PUBLIC_KEY || '';
// Endpoint del backend que recibe el `card_token_id` y crea el preapproval
// (POST /preapproval con cobro inmediato → status authorized). Todavía no
// existe; queda configurable para apuntarlo cuando se implemente el backend.
export const MP_SUBSCRIPTION_URL =
  import.meta.env.VITE_MP_SUBSCRIPTION_URL || '';
// Mock SOLO de desarrollo para verificar el front sin backend. Si está seteado
// y estamos en DEV y no hay MP_SUBSCRIPTION_URL, `createMpSubscription`
// devuelve este status sin pegarle a la red. Valores: 'authorized' | 'rejected'.
export const MP_MOCK_RESULT = (import.meta.env.VITE_MP_MOCK_RESULT || '') as
  | ''
  | 'authorized'
  | 'rejected';

// ─── Mobbex (suscripciones, Argentina) — etapa de PRUEBA ───────────────────
// Gateway alternativo a MercadoPago para clientes AR. La creación de la
// suscripción (suscripción + suscriptor + checkout) requiere credenciales
// secretas (API Key + Access Token) y por eso vive en el backend.
// Endpoint del backend (edge function / webhook n8n) que crea todo eso y
// devuelve los ids para abrir el Embed. TODAVÍA NO EXISTE: vacío ⇒
// `createMobbexSubscription` usa el mock de desarrollo.
export const MOBBEX_SUBSCRIPTION_URL =
  import.meta.env.VITE_MOBBEX_SUBSCRIPTION_URL || '';
// Mock para ver los estados de la UI sin backend ni credenciales. Se usa
// siempre que `MOBBEX_SUBSCRIPTION_URL` esté vacío. Valores: 'authorized' |
// 'rejected'. Default: 'authorized'.
export const MOBBEX_MOCK_RESULT = (import.meta.env.VITE_MOBBEX_MOCK_RESULT ||
  'authorized') as 'authorized' | 'rejected';